import * as React from 'react';
import { ArticleSubscriber } from '../../../../../amorg-common';
import { Button } from '../../../../../designSystem/button/Button';
import { AnimatedCollapsibleContent } from '../../../../../designSystem/collapsible/AnimatedCollapsibleContent';
import { Flex } from '../../../../../designSystem/compositeComponents/FlexHelpers';
import { H3 } from '../../../../../designSystem/typography/Heading';
import { InfoChip } from '../../../../../designSystem/Chip';
import { CountAvatar } from '../../../../../designSystem/avatar/CountAvatar';


type ArticleViewSubscriberPanelProps = {
    subscribers: ArticleSubscriber[];
};
export function ArticleViewSubscriberPanel (props: ArticleViewSubscriberPanelProps): JSX.Element
{
    const [show, setShow] = React.useState<boolean>(false);

    React.useEffect(() =>
    {
        setShow(props.subscribers.length < 8);
    }, [props.subscribers]);

    return (
        <Flex flexDirection="column">
            <Flex>
                <Flex gap={8} style={{ flexGrow: 1 }}>
                    <H3>Abonnenter</H3>
                    <CountAvatar count={props.subscribers.length} size='24px' />
                </Flex>
                <Button variant='text' icon={show ? 'caret_caretUp' : 'caret_caretDown'} onClick={() => setShow(!show)} />
            </Flex>
            <AnimatedCollapsibleContent open={show}>
                <Flex flexDirection='row' gap={8} style={{ flexGrow: 1, flexWrap: 'wrap' }}>
                    {props.subscribers.map((s) =>
                    {
                        return (
                            <InfoChip key={s.subscriberId}>
                                {s.companyName || s.siteId}
                            </InfoChip>
                        );
                    })}
                </Flex>

            </AnimatedCollapsibleContent>
        </Flex>
    );
}